/*jshint esversion: 9 */
// import { mapGetters, mapActions } from 'vuex';
import pdf from 'vue-pdf';
import Vue from 'vue';

export const ProjectStructureBuildingModelMixin = {
  components: {
  },
  data: () => ({
    canvas_size: 5000,
    model_offset: {x: 0, y: 0},
    model_move: {
      move: false,
      moved: false,
      initial_mouse_x: 0,
      initial_mouse_y: 0,
      initial_offsetLeft: 0,
      initial_offsetTop: 0,
    },
    model_zoom: 100, //pixel per meter
    drawing_element: {
      id: -1
    },
    draw_new_path: false,
    moving_point: false,
    moving_point_edit_index: false,
    close_path: false,
    pdf_rendering: false,
    active_plan: {
      id: 'active',
      plan_id: -1,
    },
  }),
  computed: {
    // ...mapGetters('View', [
    //   'is_show_side_bar'
    // ]),
    // visible_elements() {
    //   return this.getUObjectsFiltered({
    //     type: 'elements',
    //     filter: {
    //       visible: true
    //     }
    //   });
    // },
    visible_plans() {
      let plans = [];
      if (this.active_plan.plan_id === -1 || [4,5].includes(this.active_plan.step)) {
      plans = JSON.parse(JSON.stringify(this.getUObjectsFiltered({
          type: 'plans',
          filter: {
            visible: true
          }
        })));
        plans.forEach(plan => {
          plan.active_plan_version = [this.getUObject({type: 'planversions', id: plan.active_plan_version[0]})];
            // plan.active_plan_version.map(id => {
            //   return this.getUObject({type: 'planversions', id: id});
            // });
        });
      }
      if (this.active_plan.plan_id !== -1) {
        plans.push(this.active_plan);
      }
      return plans;
    },
    element_points() {
      let points = [];
      if (this.isEditMode) {
        if (this.drawing_element.id !== -1) {
          points =  this.drawing_element.paths[0].points;
        } else if (this.selected_tree_element.id !== -1 &&
          this.selected_tree_element.type === 'elements' &&
          this.selected_tree_element.paths.length !== 0) {
          points = this.selected_tree_element.paths[0].points;
        }
      }
      return points;
    },
    element_point_helpers() {
      let point_helpers = [];
      if (this.isEditMode && this.selected_tree_element.id !== -1 &&
        this.selected_tree_element.type === 'elements' &&
        this.selected_tree_element.paths.length !== 0) {
          let points = this.selected_tree_element.paths[0].points;
          for (let i = 0; i < points.length; i++) {
            let p1 = points[i];
            let p2 = {};
            if (i === points.length-1) {
              p2 = points[0];
            } else {
              p2 = points[i+1];
            }

            point_helpers.push({
              x: (p1.x + p2.x)/2,
              y: (p1.y + p2.y)/2,
            });
          }
      }
      return point_helpers;
    },
    plan_points() {
      let points = [];
        if (this.active_plan.plan_id !== -1) {
          points.push(this.active_plan.active_plan_version[0].scale.point_one);
          if (this.active_plan.steps_done[0]) {
            points.push(this.active_plan.active_plan_version[0].scale.point_two);
          }
          if (this.active_plan.steps_done[0] && this.active_plan.steps_done[1] && this.active_plan.steps_done[2]) {
            points.push(this.active_plan.active_plan_version[0].ref_point);
          }
        }
        return points;
      }
  },
  watch: {
    selected_tree_element: function() {
      //cancel plan import
      if (this.active_plan.plan_id !== -1) {
        this.active_plan = {id: 'active', plan_id: -1};
        this.$refs.uploadPlan.value = '';
      }
      if (this.select_spatial_el_ta_id !== -1) {
        if (this.selected_tree_element.id !== -1 && this.selected_tree_element.type === 'taktareas') {
          this.select_spatial_el_ta_id = this.selected_tree_element.id;
        } else {
          this.select_spatial_el_ta_id = -1;
          this.select_spatial_el_train_id = -1;
        }
      }
      if (this.drawing_element.id !== -1) {
        this.endDrawing();
      }

      // if (this.drawing_element.id !== -1 && val.paths.length === 0) {
      //   this.endDrawing();
      // }
      // if (this.isEditMode && val.type === 'elements' && val.paths.length !== 0) {
      //     this.startDrawing({id: val.id, element_type: val.element_type, evt: {x: 0, y: 0}});
      // }
      // this.updateCanvas();
    }
  },
  methods: {
    // ...mapActions('View', [
    //   'setShowSideBar'
    // ]),
    startDrawing(payload) {
      if (payload.id !== 'create') {
        this.drawing_element = JSON.parse(JSON.stringify(this.getUObject({type: 'elements', id: payload.id})));
      } else {
        this.drawing_element = Object.assign(JSON.parse(JSON.stringify(this.spatial_elements.find(el => el.element_type === payload.element_type))), {id: 'create'});
      }
      //new path
      if (this.drawing_element.paths.length === 0) {
        let model_div_rect = document.getElementById('project-structure-building-model').getBoundingClientRect();
        let x = payload.evt.x - model_div_rect.x;
        let y = payload.evt.y - model_div_rect.y;
        this.drawing_element.paths.push({
          fill: true,
          stroke: true,
          points: [{method: 'moveTo', x: x/this.model_zoom, y: y/this.model_zoom, z: 0}],
          values: []
        });
        this.moving_point = this.drawing_element.paths[0].points[0];
      }
      this.new_path = true;
    },
    pointMouseUp(point, index, evt) {
      //edit point
      if (this.drawing_element.id === -1 && !this.model_move.moved) {
        this.drawing_element = JSON.parse(JSON.stringify(this.selected_tree_element));
        this.moving_point = this.drawing_element.paths[0].points[index];
        this.moving_point_edit_index = index;
      }
      //new element
      else if (this.new_path) {
        if (this.close_path && index === 0 && !this.model_move.moved) {
          this.endDrawing();
        } else {
          this.setPoint(evt);
        }
      }
      //insert_point
      else if (!this.model_move.moved) {
        this.updateUDObject({
          url: [
            {elements: this.selected_tree_element.id}
          ],
          update: {
            paths: JSON.parse(JSON.stringify(this.drawing_element.paths))
          }
        });
        this.drawing_element = {
          id: -1,
        };
        this.moving_point = false;
        this.moving_point_edit_index = -1;
      }

    },
    pointHelperMouseUp(index, evt) {
      if (!this.model_move.moved) {
        this.drawing_element = JSON.parse(JSON.stringify(this.selected_tree_element));

        //new point
        let model_div_rect = document.getElementById('project-structure-building-model').getBoundingClientRect();
        let x = evt.x - model_div_rect.x;
        let y = evt.y - model_div_rect.y;

        let points = this.drawing_element.paths[0].points;

        points.splice(index+1, 0, {x: x/this.model_zoom, y: y/this.model_zoom, z: 0});
        this.moving_point = points[index+1];
        this.moving_point_edit_index = index+1;
        this.updateCanvas();
      }
    },
    setPoint(evt) {
      if (!this.model_move.moved) {
      //new point
      let model_div_rect = document.getElementById('project-structure-building-model').getBoundingClientRect();
      let x = evt.x - model_div_rect.x;
      let y = evt.y - model_div_rect.y;

      let points = this.drawing_element.paths[0].points;

      points.push({x: x/this.model_zoom, y: y/this.model_zoom, z: 0});
      this.moving_point = points[points.length-1];
      this.updateCanvas();
      }
    },
    endDrawing() {
      let points = this.drawing_element.paths[0].points;
      //create location
      if (points.length === 3 || this.close_path) {
        //calculate rectangle points
        let drawing_element_copy = JSON.parse(JSON.stringify(this.drawing_element));
        if (this.close_path) {
          drawing_element_copy.paths[0].points.splice(drawing_element_copy.paths[0].points.length-1,1);
        } else {
          let rectangle_points = [
            {x: points[0].x, y: points[0].y},
            {x: points[1].x, y: points[0].y},
            {x: points[1].x, y: points[1].y},
            {x: points[0].x, y: points[1].y},
          ];
          drawing_element_copy.paths[0].points = rectangle_points;
        }
        if (drawing_element_copy.id === 'create') {
          this.createUObject({
            url: [
              {[this.selected_tree_element.type]: this.selected_tree_element.id},
              {elements: ''},
              {showWithEntitiesNormalized: ''}
            ],
            url_prefix: `/projects/${this.project_id}/projectstructure`,
            u_object: JSON.parse(JSON.stringify(Object.assign(drawing_element_copy, {order_index: 5, parent: {type: this.selected_tree_element.type, id: this.selected_tree_element.id}})))
          }).then((element_id) => {
                this.updateTreeOrderIndex({type: this.selected_tree_element.type, id: this.selected_tree_element.id});
                //reset drawing_element
                // active_location_copy.id = location_id;
                // this.locations.push(active_location_copy);
                // this.active_location.id = 'create';
                // this.active_location.spatial_unit_id = 'create';

                let floor_area = this.calcPolygonArea(drawing_element_copy.paths[0].points);
                let perimeter = this.calcPolygonPerimeter(drawing_element_copy.paths[0].points);

                //only in development mode
                this.updateUDObject({
                  url: [
                    {elements: element_id}
                  ],
                  update: {
                    paths: drawing_element_copy.paths,
                    floor_area: floor_area,
                    perimeter: perimeter
                  }
                }).then(() => {
                  points.splice(0, points.length, points[points.length-1]);
                });
                this.updateCanvas();
              });
        } else {

          let floor_area = this.calcPolygonArea(drawing_element_copy.paths[0].points);
          let perimeter = this.calcPolygonPerimeter(drawing_element_copy.paths[0].points);

          this.updateUDObject({
            url: [
              {elements: this.drawing_element.id}
            ],
            update: {
              paths: drawing_element_copy.paths,
              floor_area: floor_area,
              perimeter: perimeter
            }
          }).then(() => {
            // active_location_copy.id = location_id;
            // this.locations.push(JSON.parse(JSON.stringify(active_location_copy)));
            // this.active_location.id = 'create';
            // this.active_location.spatial_unit_id = 'create';
            // points.splice(0, points.length, points[points.length-1]);
            this.drawing_element = {id: -1};
            this.moving_point = false;
            this.moving_point_edit_index = -1;
            this.new_path = false;
            this.updateCanvas();
          });
        }
      }
      else {
        // reset drawing_element
        // points.splice(0, points.length, points[points.length-1]);
        this.drawing_element = {id: -1};
        this.moving_point = false;
        this.moving_point_edit_index = -1;
        this.new_path = false;
        this.updateCanvas();
      }
    },
    modelMouseDown(evt) {
      this.model_move.move = true;
      this.model_move.moved = false;

      this.model_move.initial_mouse_x = evt.x;
      this.model_move.initial_mouse_y = evt.y;
      let el = document.getElementById('project-structure-building-model');
      this.model_move.initial_offsetLeft = el.offsetLeft;
      this.model_move.initial_offsetTop = el.offsetTop;

    },
    modelMouseMove(evt) {
      document.getElementById('building-model-scroll-div').focus();


      let model_div_rect = document.getElementById('project-structure-building-model').getBoundingClientRect();

      let x = evt.x - model_div_rect.x;
      let y = evt.y - model_div_rect.y;


      if (this.model_move.move) {
        this.model_move.moved = true;
        let difference_x = evt.x - this.model_move.initial_mouse_x;
        let difference_y = evt.y - this.model_move.initial_mouse_y;

        let el = document.getElementById('project-structure-building-model');
        el.style.left = this.model_move.initial_offsetLeft + difference_x + 'px';
        el.style.top = this.model_move.initial_offsetTop + difference_y + 'px';
      } else if (this.moving_point) {



        this.moving_point.x = x / this.model_zoom;
        this.moving_point.y = y / this.model_zoom;

        if (this.drawing_element.id !== -1) {
          //check if close Path
          let points = this.drawing_element.paths[0].points;
          if (points.length > 3 && Math.abs(points[0].x - this.moving_point.x) < (15 / this.model_zoom) && Math.abs(points[0].y - this.moving_point.y) < (15 / this.model_zoom)) {
            this.close_path = true;
          } else {
            this.close_path = false;
          }
        }
      }
      this.updateCanvas({x: x, y: y});
    },
    modelMouseUp(evt) {
      let difference_x = evt.x - this.model_move.initial_mouse_x;
      let difference_y = evt.y - this.model_move.initial_mouse_y;

      this.model_offset = {x: this.model_offset.x + difference_x, y: this.model_offset.y + difference_y};
      //element clicked
      if (this.drawing_element.id === -1 && this.active_plan.plan_id === -1 && !this.model_move.moved && this.hover_el_id !== -1) {
        //select elements
          if (this.select_spatial_el_ta_id !== -1) {
            let ta_selected_elements = this.getUObject({type: 'taktareas', id: this.select_spatial_el_ta_id}).elements;
            let train_selected_elements = this.getAllSelectedElements({project_id: this.project_id, train_id: this.select_spatial_el_train_id});
            //remove
            if (ta_selected_elements.includes(this.hover_el_id)) {
              this.removeUObjects({
                  url: [
                    {projects: this.project_id},
                    {trains: 0},
                    {taktareas: this.select_spatial_el_ta_id},
                    {remove: ''}
                  ],
                  u_objects: {
                    target_type: 'elements',
                    target_ids: [this.hover_el_id]
                  }
                }).then(() => {
                  this.updateCanvas();
                });
            } else if (!train_selected_elements.includes(this.hover_el_id)) {
              this.addUObjects({
                  url: [
                    {projects: this.project_id},
                    {trains: 0},
                    {taktareas: this.select_spatial_el_ta_id},
                    {add: ''}
                  ],
                  u_objects: {
                    target_type: 'elements',
                    target_ids: [this.hover_el_id]
                  }
                }).then(() => {
                  this.updateCanvas();
                });
            }
          } else {
            //edit element
            this.selected_tree_element = this.getUObject({type: 'elements', id: this.hover_el_id});
          }
      }
      this.model_move.move = false;
      this.model_move.moved = false;
    },
    modelWheel(evt) {
        // evt.preventDefault();
        let zoom_step = 10;

        let model_div_rect = document.getElementById('project-structure-building-model').getBoundingClientRect();

        let x = evt.x - model_div_rect.x;
        let y = evt.y - model_div_rect.y;

        if (evt.wheelDelta > 0) {
          let difference_x = ((x/this.model_zoom) * (this.model_zoom + zoom_step) - x);
          let difference_y = ((y/this.model_zoom) * (this.model_zoom + zoom_step) - y);
          this.model_offset = {x: this.model_offset.x - difference_x, y: this.model_offset.y - difference_y};

          this.model_zoom = this.model_zoom + zoom_step;
        } else if (this.model_zoom - zoom_step >= 1) {
          let difference_x = ((x/this.model_zoom) * (this.model_zoom - zoom_step) - x);
          let difference_y = ((y/this.model_zoom) * (this.model_zoom - zoom_step) - y);
          this.model_offset = {x: this.model_offset.x - difference_x, y: this.model_offset.y - difference_y};

          this.model_zoom = this.model_zoom - zoom_step;
        }
        this.updateCanvas({x: x, y: y});
        this.renderPDF();
    },
    modelKeyUp(evt) {
      if (['Enter', 'Escape'].includes(evt.key)) {
        if (this.drawing_element.id !== -1) {
          this.endDrawing();
        }
      }
      if (['Delete', 'Backspace'].includes(evt.key)) {
        if (this.drawing_element.id !== -1 && this.moving_point_edit_index !== -1) {
          //delete point
          this.moving_point = false;
          this.drawing_element.paths[0].points.splice(this.moving_point_edit_index, 1);

          if (this.drawing_element.paths[0].points.length === 0) {
            this.drawing_element.paths.splice(0, 1);
          }
          this.updateUDObject({
            url: [
              {elements: this.selected_tree_element.id}
            ],
            update: {
              paths: this.drawing_element.paths
            }
          });
          this.drawing_element = {
            id: -1
          };
          this.updateCanvas();
        }
      }
    },
    updateCanvas(evt) {
      let self = this;
      setTimeout(function () {
        let canvas = document.getElementById('model_canvas');
        let ctx = canvas.getContext('2d');

        //canvas size 5000x5000px
        ctx.translate(self.canvas_size / 2,self.canvas_size / 2);
        ctx.clearRect(self.canvas_size / -2,self.canvas_size / -2,self.canvas_size,self.canvas_size);
        ctx.fillStyle = 'rgba(76,175,80,0.3)';
        // ctx.scale(1.2,1.2);
        // ctx.scale(self.plan_zoom, self.plan_zoom);
        // ctx.translate(0.5,0.5);

        // scale
        if (self.active_plan.plan_id !== -1 && self.active_plan.steps_done[0]) {
          let point_one = self.active_plan.active_plan_version[0].scale.point_one;
          let point_two = self.active_plan.active_plan_version[0].scale.point_two;
          let ref_point = {x: 0, y: 0};
          if (self.active_plan.step !== 3) {
            ref_point = self.active_plan.active_plan_version[0].ref_point;
          }
          let offset = self.active_plan.offset;
          ctx.beginPath();
          ctx.moveTo((point_one.x + offset.x - ref_point.x) * self.model_zoom, (point_one.y + offset.y - ref_point.y) * self.model_zoom);
          ctx.lineTo((point_two.x + offset.x - ref_point.x) * self.model_zoom, (point_two.y + offset.y - ref_point.y) * self.model_zoom);
          ctx.closePath();
          ctx.stroke();
        }
        //measurement
        // else if (self.plan_measurement.active) {
        //   self.plan_measurement.paths.forEach(path => {
        //     if (path.points.length !== 0) {
        //       if (!path.rectangle || path.points.length > 2) {
        //         ctx.beginPath();
        //         ctx.moveTo(path.points[0].x * self.plan_zoom, path.points[0].y * self.plan_zoom);
        //         for (var i = 1; i < path.points.length; i++) {
        //           ctx.lineTo(path.points[i].x * self.plan_zoom, path.points[i].y * self.plan_zoom);
        //         }
        //         if (path.area) {
        //           ctx.closePath();
        //           ctx.fill();
        //         }
        //         ctx.stroke();
        //       } else if (path.points.length > 1) {
        //         ctx.fillRect(path.points[0].x * self.plan_zoom, path.points[0].y * self.plan_zoom, (path.points[1].x * self.plan_zoom - path.points[0].x * self.plan_zoom), (path.points[1].y* self.plan_zoom - path.points[0].y * self.plan_zoom));
        //         ctx.strokeRect(path.points[0].x * self.plan_zoom, path.points[0].y * self.plan_zoom, (path.points[1].x * self.plan_zoom - path.points[0].x * self.plan_zoom), (path.points[1].y * self.plan_zoom - path.points[0].y * self.plan_zoom));
        //       }
        //     }
        //   });
        // }
        //location
        // else {
          self.hover_el_id = -1;
          //new location
          if (self.drawing_element.id !== -1) {
            let points = self.drawing_element.paths[0].points;
            if (points.length > 3 || !self.new_path) {
              ctx.beginPath();
              ctx.moveTo(points[0].x * self.model_zoom, points[0].y * self.model_zoom);
              for (var i = 1; i < points.length; i++) {
                ctx.lineTo(points[i].x * self.model_zoom, points[i].y * self.model_zoom);
              }
              if (!self.new_path) {
                ctx.closePath();
                ctx.fill();
              }
              ctx.stroke();
            }
            else if (points.length > 1 && points.length < 4) {
              ctx.fillRect(points[0].x * self.model_zoom, points[0].y * self.model_zoom, (points[1].x * self.model_zoom - points[0].x * self.model_zoom), (points[1].y* self.model_zoom - points[0].y * self.model_zoom));
              ctx.strokeRect(points[0].x * self.model_zoom, points[0].y * self.model_zoom, (points[1].x * self.model_zoom - points[0].x * self.model_zoom), (points[1].y * self.model_zoom - points[0].y * self.model_zoom));
              if (points.length > 2) {
                ctx.beginPath();
                ctx.moveTo(points[1].x * self.model_zoom, points[1].y * self.model_zoom);
                ctx.lineTo(points[2].x * self.model_zoom, points[2].y * self.model_zoom);
                ctx.stroke();
              }
            }
          }
          // elements
          if (self.active_plan.plan_id === -1 || [4,5].includes(self.active_plan.step)) {
          self.visible_elements.forEach(element => {
            if (element.paths.length !== 0 && element.id !== self.drawing_element.id) {
              //color
              if (self.selected_tree_element.type === 'elements' && self.selected_tree_element.id === element.id) {
                ctx.fillStyle = 'rgba(76,175,80,0.3)';
              } else if (self.selected_tree_element.type !== 'elements' && self.selected_tree_element_children.includes(element.id)) {
                ctx.fillStyle = 'rgba(76,175,80,0.3)';
              } else {
                ctx.fillStyle = 'rgba(158,158,158,0.3)';
              }

              ctx.beginPath();
              ctx.moveTo(element.paths[0].points[0].x * self.model_zoom, element.paths[0].points[0].y * self.model_zoom);
              for (var i = 1; i < element.paths[0].points.length; i++) {
                ctx.lineTo(element.paths[0].points[i].x * self.model_zoom, element.paths[0].points[i].y * self.model_zoom);
              }

              ctx.closePath();
              ctx.fill();
              ctx.stroke();
              if (evt && ctx.isPointInPath(evt.x + self.canvas_size/2, evt.y + self.canvas_size/2)) {
                self.hover_el_id = element.id;
              }
            }
          });
        }
        // }
        ctx.translate(self.canvas_size / -2,self.canvas_size / -2);
      }, 1);
    },
    renderPDF() {
      this.visible_plans.forEach(plan => {
      if (!plan.rendering) {
        plan.rendering = true;

        let self = this;
        let url = plan.active_plan_version[0].url;

        let loading_task = pdf.createLoadingTask(url);
        // Asynchronous download PDF
        loading_task.promise.then(function(pdf) {
          return pdf.getPage(1);
        })
        .then(function(page) {
          // Set scale (zoom) level
          let scale = (self.model_zoom/ 100) * 2 * plan.active_plan_version[0].scale.scale_factor;

          // Get viewport (dimensions)
          let viewport = page.getViewport({ scale: scale });
          // Get canvas#the-canvas
          let canvas = document.getElementById(`plan_canvas_${plan.id}`);

          // Fetch canvas' 2d context
          let context = canvas.getContext('2d');

          context.translate(self.canvas_size / 2,self.canvas_size / 2);

          // Set dimensions to Canvas
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          if (!plan.active_plan_version[0].file_width) {
            plan.active_plan_version[0].file_width = viewport.viewBox[2];
          }


          // canvas.width = 1000;
          // canvas.height = 1000;

          // canvas.style.height = "100%";
          // canvas.style.width = `${100 * self.plan_zoom}%`;

          // Prepare object needed by render method
          let renderContext = {
            canvasContext: context,
            viewport: viewport
          };

          // Render PDF page
          let renderTask = page.render(renderContext);
          renderTask.promise.then(function () {
            plan.rendering = false;
          });
        });
      }
    });
    },
    selectPlan(file) {
      this.active_plan = {
        step: 0,
        steps_done: [false, false, false, false, false],
        id: 'active',
        plan_id: 'create',
        name: file.name.split('.')[0],
        description: '',
        offset: {x: 0, y: 0},
        rendering: false,
        visible: false,
        order_index: -5,
        type: 'plans',
        planversions: [],
        parent: {
          type: this.selected_tree_element.type,
          id: this.selected_tree_element.id
        },
        active_plan_version: [{
          file_name: file.name,
          file_date: file.lastModifiedDate,
          file_width: false,
          url: URL.createObjectURL(file),
          ref_point: {x: 0, y: 0},
          scale: {
            point_one: {x: 0, y: 0},
            point_two: {x: 0, y: 0},
            length: 1.00,
            scale_factor: 1,
          },
        }],
      };
      this.moving_point = this.active_plan.active_plan_version[0].scale.point_one;
      this.renderPDF();
    },
    planPointMouseUp(evt) {
      let model_div_rect = document.getElementById('project-structure-building-model').getBoundingClientRect();
      let x = JSON.parse(JSON.stringify((evt.x - model_div_rect.x) / this.model_zoom));
      let y = JSON.parse(JSON.stringify((evt.y - model_div_rect.y) / this.model_zoom));

      if (this.active_plan.step === 0) {
        this.active_plan.active_plan_version[0].scale.point_one = {x: x, y: y};
        this.active_plan.step = 1;
        this.active_plan.steps_done.splice(0, 1, true);
        this.moving_point = this.active_plan.active_plan_version[0].scale.point_two;
      }
      else if (this.active_plan.step === 1) {
        this.active_plan.active_plan_version[0].scale.point_two = {x: x, y: y};
        this.active_plan.step = 2;
        this.active_plan.steps_done.splice(1, 1, true);
      }
      else if (this.active_plan.step === 3) {
        this.active_plan.active_plan_version[0].ref_point = {x: x, y: y};
        this.active_plan.step = 4;
        this.active_plan.steps_done.splice(3, 1, true);
        this.moving_point = this.active_plan.offset;
        this.updateCanvas();
      }
      else if (this.active_plan.step === 4) {
        this.active_plan.offset = {x: x, y: y};
        this.active_plan.step = 5;
        this.active_plan.steps_done.splice(4, 1, true);
        this.moving_point = false;
        this.moving_point_edit_index = -1;
        this.updateCanvas();
      }
    },
    planSetScale(value) {

      let required_length = parseFloat(value).toFixed(2);

      this.active_plan.active_plan_version[0].scale.length = required_length;

      let p1 = this.active_plan.active_plan_version[0].scale.point_one;
      let p2 = this.active_plan.active_plan_version[0].scale.point_two;
      let ref_p = this.active_plan.active_plan_version[0].ref_point;

      let actual_scale_factor = JSON.parse(JSON.stringify(this.active_plan.active_plan_version[0].scale.scale_factor));
      let actual_length = Math.sqrt(Math.pow((p2.x / actual_scale_factor - p1.x / actual_scale_factor),2) + Math.pow((p2.y / actual_scale_factor - p1.y / actual_scale_factor),2));

      let scale_factor = required_length / actual_length;
      this.active_plan.active_plan_version[0].scale.scale_factor = JSON.parse(JSON.stringify(scale_factor));


      p1.x = JSON.parse(JSON.stringify((p1.x / actual_scale_factor) * scale_factor));
      p1.y = JSON.parse(JSON.stringify((p1.y / actual_scale_factor) * scale_factor));
      p2.x = JSON.parse(JSON.stringify((p2.x / actual_scale_factor) * scale_factor));
      p2.y = JSON.parse(JSON.stringify((p2.y / actual_scale_factor) * scale_factor));
      ref_p.x = JSON.parse(JSON.stringify((ref_p.x / actual_scale_factor) * scale_factor));
      ref_p.y = JSON.parse(JSON.stringify((ref_p.y / actual_scale_factor) * scale_factor));

      this.renderPDF();
      this.updateCanvas();

    },
    planSave() {
      let new_plan = JSON.parse(JSON.stringify(this.active_plan));
      Vue.delete(new_plan, 'step');
      Vue.delete(new_plan, 'steps_done');
      Vue.delete(new_plan, 'plan_id');
      Vue.set(new_plan, 'active_plan_version', []);


      this.createUDObject({
        url: [
          {[this.selected_tree_element.type]: this.selected_tree_element.id},
          {'plans': ''},
          {showWithEntitiesNormalized: ''}
        ],
        url_prefix: `/projects/${this.project_id}/projectstructure`,
        resp_data: {
          plans: [new_plan]
        },
      }).then(plan_id => {
        let new_plan_version = JSON.parse(JSON.stringify(this.active_plan.active_plan_version[0]));
        this.createUDObject({
          url: [
            {plans: plan_id},
            {'planversions': ''},
            {showWithEntitiesNormalized: ''}
          ],
          url_prefix: `/projects/${this.project_id}/projectstructure`,
          resp_data: {
            planversions: [new_plan_version]
          },
        }).then(id => {
          this.updateUDObject({
            url: [
              {plans: plan_id}
            ],
            update: {
              active_plan_version: [id],
              visible: true,
            }
          });
          this.active_plan = {
            id: 'active',
            plan_id: -1,
          };
          this.$refs.uploadPlan.value = '';
          this.renderPDF();
          this.updateCanvas();

        });
      });
    },
    calcPolygonArea(points) {
      var total = 0;

      for (let i = 0, l = points.length; i < l; i++) {
        let addX = points[i].x;
        let addY = points[i == points.length - 1 ? 0 : i + 1].y;
        let subX = points[i == points.length - 1 ? 0 : i + 1].x;
        let subY = points[i].y;

        total += (addX * addY * 0.5);
        total -= (subX * subY * 0.5);
      }
      // let area = Math.abs(total / (this.plan_scale.pixcel_per_length * this.plan_scale.pixcel_per_length));
      let area = Math.abs(total);
      area = Math.round(area * 100) / 100;
      return area;
    },
    calcPolygonPerimeter(points) {
      let perimeter = 0;

      for (let i = 0; i < points.length-1; i++) {
        let p1 = points[i];
        let p2 = points[i+1];
        perimeter = perimeter + Math.sqrt(Math.pow((p2.x - p1.x),2) + Math.pow((p2.y - p1.y),2));
      }
      let last = points[points.length-1];
      let first = points[0];

      perimeter = perimeter + Math.sqrt(Math.pow((first.x - last.x),2) + Math.pow((first.y - last.y),2));

      perimeter = Math.round(perimeter * 100) / 100;
      return perimeter;
    }
  }
};
